export const Constants = {
  TD: 'TD',
  CD: 'CD',
  PRV: 'PRV',
  ZN: 'ZN',
  SELLER:'SELLER',
  HOME_DELIVERY: 'Despacho a Domicilio',
  RETIRO_EN_TIENDA: 'Retiro en Tienda',
  ENTITY_TYPES: [
    { id: 'TD', text: 'Tienda', default: true },
    { id: 'CD', text: 'Centro de distribución', default: false },
    { id: 'PRV', text: 'Proveedor', default: false },
    { id: 'SELLER', text: 'Seller', default: false }

  ],
  ENTITY_TYPES_CD_AND_TD: [
    { id: 'TD', text: 'Tienda'},
    { id: 'CD', text: 'Centro de distribución'}
  ],
  ENTITY_TYPES_CD_AND_TD_AND_SELLER: [
    { id: 'TD', text: 'Tienda'},
    { id: 'CD', text: 'Centro de distribución'},
    { id: 'SELLER', text: 'Seller' }
  ],
    ENTITY_TYPES_CD_AND_TD_AND_SELLER_AND_PROVIDER: [
    { id: 'TD', text: 'Tienda'},
    { id: 'CD', text: 'Centro de distribución'},
    { id: 'PRV', text: 'Proveedor', default: false },
    { id: 'SELLER', text: 'Seller' }
  ],
  isPickitEntity: ["OE-8160", "SPSA-1533", "SPSA-1511"]
};
